export const STATUS_LABELS = {
  draft: "Draft",
  menunggu_persetujuan: "Menunggu Persetujuan",
  disetujui: "Disetujui",
  ditolak: "Ditolak",
  dalam_perbaikan: "Dalam Perbaikan",
  selesai: "Selesai Diperbaiki",
  final: "Laporan Final Terbit",
};

export const STATUS_STYLES = {
  draft: "bg-slate-100 text-slate-600 border-slate-200 rounded-full",
  menunggu_persetujuan: "bg-amber-100 text-amber-700 border-amber-200 rounded-full",
  disetujui: "bg-sky-100 text-sky-700 border-sky-200 rounded-full",
  ditolak: "bg-rose-100 text-rose-700 border-rose-200 rounded-full",
  dalam_perbaikan: "bg-cyan-100 text-cyan-800 border-cyan-200 rounded-full",
  selesai: "bg-teal-100 text-teal-800 border-teal-200 rounded-full",
  final: "bg-teal-700 text-white border-teal-700 rounded-full",
};

export const URGENCY_LABELS = {
  rendah: "Rendah",
  sedang: "Sedang",
  tinggi: "Tinggi",
  darurat: "Darurat",
};

export const URGENCY_STYLES = {
  rendah: "bg-slate-100 text-slate-600 border-slate-200 rounded-full",
  sedang: "bg-sky-100 text-sky-700 border-sky-200 rounded-full",
  tinggi: "bg-orange-100 text-orange-700 border-orange-200 rounded-full",
  darurat: "bg-rose-100 text-rose-700 border-rose-200 rounded-full",
};

export const ROLE_LABELS = {
  pelapor: "Pelapor",
  approver: "Approver Divisi",
  technician: "Petugas Bengkel",
  admin: "Admin",
};

export const STAGE_LABELS = {
  diperiksa: "Diperiksa",
  menunggu_sparepart: "Menunggu Sparepart",
  dikerjakan: "Dikerjakan",
  selesai: "Selesai",
};

export const REPAIR_TYPE_LABELS = {
  penggantian_sparepart: "Penggantian Sparepart",
  service: "Service (Tanpa Penggantian Sparepart)",
  keduanya: "Penggantian Sparepart + Service",
};

export const BAPS_STATUS_LABELS = {
  menunggu_ttd: "Menunggu Tanda Tangan Basah",
  ditandatangani: "Ditandatangani",
};

export function fmtDate(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

export function fmtDateShort(iso) {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
}

export function fmtRupiah(n) {
  if (n == null || n === "") return "Rp 0";
  return "Rp " + Number(n).toLocaleString("id-ID");
}
